module.exports = __webpack_public_path__ + "static/media/winter_super_pack_dog_bed_FR.c56d0a1d.png";